const AmazonCognitoIdentity = require('amazon-cognito-identity-js');

const reVerifyUser = (userdata) => {
  const poolData = {
    UserPoolId: process.env.VUE_APP_AWS_USER_POOL_ID, // Your user pool id here
    ClientId: process.env.VUE_APP_AWS_USER_CLIENT_ID, // Your client id here
  };


  const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);


  const userData = {
    Username: userdata.id,
    Pool: userPool,
  };
  const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
  // eslint-disable-next-line func-names
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line func-names
    function responsehandler(err,result) {
      if(err) {
        reject(err);
      }
      resolve(result);
    }
    cognitoUser.resendConfirmationCode(responsehandler)
  });
};


export {
  reVerifyUser as
  default,
};
